import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';
import ExternalUsers from './screens/ExternalCompanies';

const routes = [
  {
    component: ExternalUsers,
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.COMPANIES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routes;
